import { Injectable } from '@angular/core';
import { TabConfig } from './models/tab-config.model';
import { SplitterConfig } from './models/splitter-config.model';

@Injectable({
  providedIn: 'root',
})
export class PanelConfigService {
  private readonly STORAGE_KEY = 'panelGestionConfig';
  private readonly TAB_STORAGE_KEY = 'tabSelected';
  private readonly SPLITTERS_STORAGE_KEY = 'splittersState';

  public saveOpenTabs(components: TabConfig[]): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(components));
  }

  public loadOpenTabs(): TabConfig[] {
    const savedConfig = localStorage.getItem(this.STORAGE_KEY);
    return savedConfig ? JSON.parse(savedConfig) : [];
  }

  public saveCurrentTab(currentTab: TabConfig): void {
    localStorage.setItem(this.TAB_STORAGE_KEY, JSON.stringify(currentTab));
  }

  public getCurrentTab(): TabConfig | null {
    try {
      const currentTab = JSON.parse(localStorage.getItem(this.TAB_STORAGE_KEY));
      return currentTab;
    } catch (_) {
      return null;
    }
  }

  public loadSplitterState(): SplitterConfig[] {
    const savedConfig = localStorage.getItem(this.SPLITTERS_STORAGE_KEY);
    return savedConfig ? JSON.parse(savedConfig) : [];
  }

  public saveSplitterStates(splittersState: SplitterConfig[]): void {
    localStorage.setItem(this.SPLITTERS_STORAGE_KEY, JSON.stringify(splittersState));
  }

  public getSplitterState(): SplitterConfig[]{
    try {
      const splittersState = JSON.parse(localStorage.getItem(this.SPLITTERS_STORAGE_KEY));
      return splittersState;
    } catch (_) {
      return null;
    }
  }
}
